import React from 'react';
import { View } from 'react-native';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';

import FrameworkTestKeys from '../../../FrameworkTestKeys';

import styles from './NoBalanceHistory.Styles';

const NoBalaceHistory = () => (
  <View style={styles.container} testID={FrameworkTestKeys.NoBalaceHistoryComponentView}>
    <VFText
      i18nKey="balance_screen_no_history_title"
      type="primary"
      style={styles.title}
      testKey={FrameworkTestKeys.NoBalaceHistoryComponentTitleText}
    />
    <VFText
      i18nKey="balance_screen_no_history_subtitle"
      type="primary"
      style={styles.description}
      testKey={FrameworkTestKeys.NoBalaceHistoryComponentSubtitleText}
    />
  </View>
);

export default NoBalaceHistory;
